import { Pipe, PipeTransform } from '@angular/core';

import { Location } from '@sondermind/utilities/models-location';
import { formatZipCode } from '@sondermind/utilities/tools';

@Pipe({
  name: 'formatAddress',
  standalone: true,
})
export class FormatAddressPipe implements PipeTransform {
  transform(location: Location | null | undefined): string {
    if (!location) {
      return '';
    }
    const addressParts = [
      location.addressLine1,
      location.addressLine2 ? `, ${location.addressLine2}` : '',
      `, ${location.city}, ${location.state} ${formatZipCode(location.postalCode)}`
    ];
    return addressParts.join('');
  }
}
